export function determineResultType(answers) {
  let underinsuredScore = 0;
  let overpayingScore = 0;
  let confusionScore = 0;

  // Q2: Last review
  const lastReview = answers.lastReview?.[0];
  if (['3-5_years', '5+_years', 'never'].includes(lastReview)) {
    underinsuredScore += 2;
    overpayingScore += 1;
  }

  // Q3: Replacement cost knowledge
  const repCost = answers.replacementCost?.[0];
  if (repCost === 'no' || repCost === 'whats_difference') {
    underinsuredScore += 3;
    confusionScore += 2;
  }

  // Q4: Main concern
  const concern = answers.mainConcern?.[0];
  if (['not_enough_coverage', 'coverage_gaps'].includes(concern)) {
    underinsuredScore += 3;
  } else if (concern === 'paying_too_much') {
    overpayingScore += 3;
  } else if (['dont_understand', 'not_sure'].includes(concern)) {
    confusionScore += 3;
  }

  // Q5: Additional structures (2+ = likely gaps)
  const structures = answers.additionalStructures || [];
  const validStructures = structures.filter(s => s !== 'none');
  if (validStructures.length >= 2) {
    underinsuredScore += 2;
  }

  // Q6: Disaster coverage uncertainty
  const disasters = answers.disasterCoverage || [];
  if (disasters.includes('not_sure')) {
    underinsuredScore += 2;
    confusionScore += 2;
  }

  // Determine path
  if (underinsuredScore >= 5) return 'underinsured';
  if (overpayingScore >= 3 && confusionScore < 3) return 'overpaying';
  return 'coverage_gaps'; 
}

export function calculateLeadScore(answers, resultType) {
  let score = 50; // Base score

  if (resultType === 'underinsured') score += 30;
  if (resultType === 'overpaying') score += 20;
  
  const lastReview = answers.lastReview?.[0];
  if (['never', '5+_years'].includes(lastReview)) score += 10;
  
  const structures = (answers.additionalStructures || []).filter(s => s !== 'none');
  if (structures.length >= 3) score += 10;
  
  const disasters = answers.disasterCoverage || [];
  if (disasters.includes('earthquake') || disasters.includes('wildfire')) score += 10;

  return Math.min(score, 100);
}